import { useNotifications } from "../context/NotificationContext";

export const useNotificationHandlers = () => {
  const {
    markAsRead,
    markAllAsRead,
    removeNotification,
    clearAllNotifications,
  } = useNotifications();

  const handleMarkAsRead = async (id: string) => {
    try {
      await markAsRead(id);
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      await markAllAsRead();
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  };

  const handleRemove = async (id: string) => {
    try {
      await removeNotification(id);
    } catch (error) {
      console.error("Error removing notification:", error);
    }
  };

  const handleClearAll = async () => {
    try {
      await clearAllNotifications();
    } catch (error) {
      console.error("Error clearing all notifications:", error);
    }
  };

  return {
    handleMarkAsRead,
    handleMarkAllAsRead,
    handleRemove,
    handleClearAll,
  };
};
